import invoices from "./invoices.component";
import invoicesUrls from "./invoices.urls";
import InvoicesTransforms from "./invoices.transforms";

const invoicesModule = angular
  .module("app.components.invoices", [])
  .component("invoicesPage", invoices)
  .service("InvoicesTransforms", InvoicesTransforms)
  .config(invoicesUrls);

export default invoicesModule;



// WEBPACK FOOTER //
// ./src/pages/invoices/invoices.module.js